export default __webpack_public_path__ + "static/media/moraleboost.24bd8e42.png";